// LUCHADOR SHOPI 2027 — v28
// Catálogo desde Shopify Admin como única fuente de verdad.
// Cambios respecto de v26:
//  · − RASHGUARD FEST X EQUIPOS. Era duplicado de RASHGUARD TEAM LUCHADOR
//    (misma prenda, otra foto). En v25 lo había repuesto por error creyendo
//    que se había borrado sin querer. Producto archivado en Shopify.
//  · El producto CONJUNTO CHILE (10593379811616) NO va en esta grilla a
//    propósito: se vende desde la sección de promo y desaparece con ella.
// La promo Mes de la Patria vive aparte, en assets/luchador-promo.js.
// Pendiente conocido: APE RASHGUARD MILITARY (activo pero sin foto en Shopify)
// y Torneo EA FC 26. La Mochila 40L se inyecta desde layout/theme.liquid.

const LUCH = {

  products: [
    // ── RASHGUARDS ──
    {
      id:'10415116386592', type:'rashguard', badge:'New', price:55000,
      handle:'rashguard-blue-luchador-stretchdry-max',
      title:'RASHGUARD BLUE LUCHADOR – StretchDry Max™',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/RASHBLUEFRONT.png?v=1781936596',
      sizes:['S','M','L','XL','2XL'],
      variants:[
        {id:'51889719804192',size:'S',  stock:5},
        {id:'51889719836960',size:'M',  stock:6},
        {id:'51889719869728',size:'L',  stock:4},
        {id:'51889719902496',size:'XL', stock:6},
        {id:'51889719935264',size:'2XL',stock:3},
      ]
    },
    {
      id:'10419153404192', type:'rashguard', badge:'New', price:55000,
      handle:'rashguard-purple-luchador-stretchdry-max™',
      title:'RASHGUARD PURPLE LUCHADOR – StretchDry Max™',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPTImage21jun2026_03_34_48a.m..png?v=1782027451',
      sizes:['S','M','L','XL','2XL','3XL'],
      variants:[
        {id:'51894901571872',size:'S',  stock:3},
        {id:'51894901604640',size:'M',  stock:1},
        {id:'51894901637408',size:'L',  stock:3},
        {id:'51894901670176',size:'XL', stock:3},
        {id:'51894901702944',size:'2XL',stock:2},
        {id:'52060925329696',size:'3XL',stock:1},
      ]
    },
    {
      id:'10233733710112', type:'rashguard', price:60000,
      handle:'rashguard-chile-2026-2027-copia',
      title:'Rashguard Chile Oficial 2026–2027 | Grappling',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPTImage11jun2026_10_10_30p.m..png?v=1781230384',
      colors:['Rojo','Azul'],
      colorImgs:{
        'Rojo':'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPTImage11jun2026_10_10_30p.m..png?v=1781230384',
        'Azul':'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/rashguard_chile_2026_-_2027_LUCHADOR.png?v=1781230859',
      },
      sizes:['XS','S','M','L','XL','2XL','3XL'],
      variants:[
        {id:'51334685393184',color:'Rojo',size:'XS', stock:0},
        {id:'51334685425952',color:'Rojo',size:'S',  stock:2},
        {id:'51334685458720',color:'Rojo',size:'M',  stock:4},
        {id:'51334685491488',color:'Rojo',size:'L',  stock:2},
        {id:'51334685524256',color:'Rojo',size:'XL', stock:4},
        {id:'51334685557024',color:'Rojo',size:'2XL',stock:4},
        {id:'51334685589792',color:'Rojo',size:'3XL',stock:0},
        {id:'51334685622560',color:'Azul',size:'XS', stock:0},
        {id:'51334685655328',color:'Azul',size:'S',  stock:3},
        {id:'51334685688096',color:'Azul',size:'M',  stock:3},
        {id:'51334685720864',color:'Azul',size:'L',  stock:2},
        {id:'51334685753632',color:'Azul',size:'XL', stock:3},
        {id:'51334685786400',color:'Azul',size:'2XL',stock:5},
        {id:'51334685819168',color:'Azul',size:'3XL',stock:0},
      ]
    },
    {
      id:'10331672510752', type:'rashguard', badge:'New', price:60000,
      handle:'rashguard-grappling-stretchdry-max™',
      title:'RASHGUARD TEAM LUCHADOR – StretchDry Max™',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/RASHGUARD_LUCHADOR_TEAM_4f5ee2ab-fbae-4110-8642-35a04ab2d774.png?v=1788590175',
      sizes:['XS','S','M','L','XL','2XL'],
      variants:[
        {id:'51736203231520',size:'XS', stock:0},
        {id:'51736203198752',size:'S',  stock:2},
        {id:'51736203067680',size:'M',  stock:1},
        {id:'51736203165984',size:'L',  stock:1},
        {id:'51736203133216',size:'XL', stock:4},
        {id:'51736203100448',size:'2XL',stock:2},
      ]
    },
    {
      id:'10150633898272', type:'rashguard', price:60000,
      handle:'rashguard-luchador-tecnologia-stretchdry-max™',
      title:'Rashguard Grappling Competencia White & Black | StretchDry Max™',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPT_Image_28_abr_2026_02_10_04_a.m..png?v=1777356680',
      colors:['Blanco','Negro'],
      sizes:['XS','S','M','L','XL','2XL'],
      variants:[
        {id:'51080360526112',color:'Blanco',size:'XS', stock:0},
        {id:'51080360558880',color:'Blanco',size:'S',  stock:3},
        {id:'51080360591648',color:'Blanco',size:'M',  stock:0},
        {id:'51080360624416',color:'Blanco',size:'L',  stock:1},
        {id:'51080360657184',color:'Blanco',size:'XL', stock:3},
        {id:'51080360689952',color:'Blanco',size:'2XL',stock:3},
        {id:'51082225090848',color:'Negro', size:'XS', stock:1},
        {id:'51082225123616',color:'Negro', size:'S',  stock:1},
        {id:'51082225156384',color:'Negro', size:'M',  stock:0},
        {id:'51082225189152',color:'Negro', size:'L',  stock:0},
        {id:'51082225221920',color:'Negro', size:'XL', stock:0},
        {id:'51082225254688',color:'Negro', size:'2XL',stock:0},
      ]
    },
    {
      id:'10488231231776', type:'rashguard', price:55000,
      handle:'piel-luchador-rashguard-luchador®',
      title:'RASHGUARD LUCHADOR CH NAHUEL 3XW',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPT_Image_7_ago_2026_01_01_12_a.m._a10de7c3-eb81-4a1d-a2f2-f8119655baf6.png?v=1786079299',
      sizes:['S','M','L','XL','XXL','XXXL'],
      variants:[
        {id:'52013799080224',size:'S',   stock:2},
        {id:'52013799112992',size:'M',   stock:0},
        {id:'52013799145760',size:'L',   stock:0},
        {id:'52013799178528',size:'XL',  stock:1},
        {id:'52013799211296',size:'XXL', stock:2},
        {id:'52013799244064',size:'XXXL',stock:1},
      ]
    },
    {
      id:'10534073270560', type:'rashguard', price:60000,
      handle:'rashguard-luchador-cafe-stretchdry-max™',
      title:'RASHGUARD LUCHADOR CAFE – StretchDry Max™',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/RASHGUARD_CAFE_9a43a4e0-787b-4eb0-a0ea-14c518521519.png?v=1786079165',
      sizes:['XS','S','M','L','XL','XXL','XXXL'],
      variants:[
        {id:'52157642703136',size:'XS',  stock:0},
        {id:'52157642735904',size:'S',   stock:0},
        {id:'52157642768672',size:'M',   stock:1},
        {id:'52157642801440',size:'L',   stock:2},
        {id:'52157642834208',size:'XL',  stock:1},
        {id:'52157642866976',size:'XXL', stock:0},
        {id:'52157642899744',size:'XXXL',stock:0},
      ]
    },
    {
      id:'10548023951648', type:'rashguard', badge:'New', price:60000,
      handle:'luchador-x-technique-protocol-stretchdry-max™',
      title:'LUCHADOR x TECHNIQUE PROTOCOL – StretchDry Max™',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/LUCHADOR_x_TECHNIQUE_PROTOCOL_StretchDry_Max_FRONT..png?v=1787039278',
      sizes:['XS','S','M','L','XL','3XL'],
      variants:[
        {id:'52202172416288',size:'XS', stock:0},
        {id:'52202172449056',size:'S',  stock:0},
        {id:'52202172481824',size:'M',  stock:3},
        {id:'52202172514592',size:'L',  stock:2},
        {id:'52202172547360',size:'XL', stock:2},
        {id:'52202172580128',size:'3XL',stock:1},
      ]
    },
    {
      id:'10548023984416', type:'rashguard', badge:'New', price:60000,
      handle:'brasil-grappling-x-luchador-stretchdry-max™',
      title:'BRASIL GRAPPLING x LUCHADOR – StretchDry Max™',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/BRASIL_GRAPPLING_X_LUCHADOR_StretchDry_Max.png?v=1787038203',
      sizes:['XS','S','M','L','XL','3XL'],
      variants:[
        {id:'52202172612896',size:'XS', stock:0},
        {id:'52202172645664',size:'S',  stock:3},
        {id:'52202172678432',size:'M',  stock:3},
        {id:'52202172711200',size:'L',  stock:3},
        {id:'52202172743968',size:'XL', stock:3},
        {id:'52202172776736',size:'3XL',stock:1},
      ]
    },
    {
      id:'10548024049952', type:'rashguard', badge:'New', price:60000,
      handle:'luchador-x-technique-hunter-stretchdry-max™',
      title:'LUCHADOR x TECHNIQUE HUNTER – StretchDry Max™',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/LUCHADOR_x_TECHNIQUE_HUNTER_StretchDry_Max_FRONT.png?v=1787037156',
      sizes:['XS','S','M','L','XL','3XL'],
      variants:[
        {id:'52202172973344',size:'XS', stock:0},
        {id:'52202173006112',size:'S',  stock:3},
        {id:'52202173038880',size:'M',  stock:3},
        {id:'52202173071648',size:'L',  stock:3},
        {id:'52202173104416',size:'XL', stock:3},
        {id:'52202173137184',size:'3XL',stock:0},
      ]
    },
    {
      id:'10548024082720', type:'rashguard', badge:'New', price:60000,
      handle:'luchador-x-flowhawk-toxic-stretchdry-max™',
      title:'LUCHADOR x FLOWHAWK TOXIC – StretchDry Max™',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/LUCHADOR_x_FLOWHAWK_TOXIC_StretchDry_Max.png?v=1787036109',
      sizes:['XS','S','M','L','XL','3XL'],
      variants:[
        {id:'52202173169952',size:'XS', stock:0},
        {id:'52202173202720',size:'S',  stock:2},
        {id:'52202173235488',size:'M',  stock:2},
        {id:'52202173268256',size:'L',  stock:3},
        {id:'52202173301024',size:'XL', stock:3},
        {id:'52202173333792',size:'3XL',stock:1},
      ]
    },
    {
      id:'10548024312096', type:'rashguard', badge:'New', price:60000,
      handle:'luchador-x-technique-rasta-stretchdry-max™',
      title:'LUCHADOR x TECHNIQUE RASTA – StretchDry Max™',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/LUCHADOR_x_TECHNIQUE_RASTA_StretchDry_Max_FRONT.png?v=1787039987',
      sizes:['XS','S','M','L','XL','3XL'],
      variants:[
        {id:'52202173989152',size:'XS', stock:0},
        {id:'52202174021920',size:'S',  stock:2},
        {id:'52202174054688',size:'M',  stock:3},
        {id:'52202174087456',size:'L',  stock:2},
        {id:'52202174120224',size:'XL', stock:3},
        {id:'52202174152992',size:'3XL',stock:1},
      ]
    },
    {
      id:'10488231690528', type:'rashguard', badge:'New', price:60000,
      handle:'rashguard-pinkflow-luchador®',
      title:'RASHGUARD PINKFLOW – LUCHADOR® – StretchDry Max™',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/LUCHADOR_PINK_FLOW_bdcef3de-6e44-4612-806c-f5ba2b5985fa.png?v=1787076937',
      sizes:['XXS','XS','S','M','L','XL'],
      variants:[
        {id:'52013800685856',size:'XXS',stock:2},
        {id:'52013800718624',size:'XS', stock:1},
        {id:'52013800751392',size:'S',  stock:2},
        {id:'52013800784160',size:'M',  stock:2},
        {id:'52013800816928',size:'L',  stock:1},
        {id:'52013800849696',size:'XL', stock:0},
      ]
    },
    // ── SINGLETS ──
    {
      id:'9988161044768', type:'singlet', price:75000,
      handle:'wrestling-singlets-chile-oficial',
      title:'Malla Wrestling Chile Oficial | StretchDry Max™',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPTImage17feb2026_11_24_43a.m..png?v=1771338313',
      colors:['Rojo','Azul'],
      colorImgs:{
        'Rojo':'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPTImage17feb2026_11_24_43a.m..png?v=1771338313',
        'Azul':'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPT_Image_17_feb_2026_11_26_03_a.m..png?v=1771338383',
      },
      sizes:['XS','S','M','L','XL','XXL','XXXL'],
      variants:[
        {id:'51082294067488',color:'Rojo',size:'XS',  stock:0},
        {id:'51082294100256',color:'Rojo',size:'S',   stock:1},
        {id:'51082294133024',color:'Rojo',size:'M',   stock:0},
        {id:'51082294165792',color:'Rojo',size:'L',   stock:2},
        {id:'51082294198560',color:'Rojo',size:'XL',  stock:1},
        {id:'51082294231328',color:'Rojo',size:'XXL', stock:1},
        {id:'51082294264096',color:'Rojo',size:'XXXL',stock:0},
        {id:'51082294296864',color:'Azul',size:'XS',  stock:0},
        {id:'51082294329632',color:'Azul',size:'S',   stock:0},
        {id:'51082294362400',color:'Azul',size:'M',   stock:0},
        {id:'51082294395168',color:'Azul',size:'L',   stock:2},
        {id:'51082294427936',color:'Azul',size:'XL',  stock:1},
        {id:'51082294460704',color:'Azul',size:'XXL', stock:1},
        {id:'51082294493472',color:'Azul',size:'XXXL',stock:0},
      ]
    },
    {
      id:'10062758117664', type:'singlet', price:65000,
      handle:'wrestling-singlets-argentina-uww-2025-2026-luchador®',
      title:'ARGENTINA WRESTLING SINGLETS UWW 2025–2026',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPTImage30sept2025_01_15_51a.m._dee2907e-bed7-49f2-8ade-2720b6a21290.png?v=1773615232',
      colors:['Azul','Rojo'],
      colorImgs:{
        'Azul':'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPTImage30sept2025_01_15_51a.m._dee2907e-bed7-49f2-8ade-2720b6a21290.png?v=1773615232',
        'Rojo':'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPTImage30sept2025_01_57_35a.m._8ba35425-1010-4792-9854-8a1fa326e77e.png?v=1773615414',
      },
      sizes:['XS','S','M','L','XL','2XL','3XL'],
      variants:[
        {id:'51347251167520',color:'Azul',size:'XS', stock:4},
        {id:'51347248120096',color:'Azul',size:'S',  stock:4},
        {id:'51347251200288',color:'Azul',size:'M',  stock:4},
        {id:'51347251233056',color:'Azul',size:'L',  stock:4},
        {id:'51347251265824',color:'Azul',size:'XL', stock:4},
        {id:'51347251298592',color:'Azul',size:'2XL',stock:4},
        {id:'51347251331360',color:'Azul',size:'3XL',stock:4},
        {id:'51347251364128',color:'Rojo',size:'XS', stock:4},
        {id:'51347248152864',color:'Rojo',size:'S',  stock:4},
        {id:'51347251396896',color:'Rojo',size:'M',  stock:4},
        {id:'51347251429664',color:'Rojo',size:'L',  stock:4},
        {id:'51347251462432',color:'Rojo',size:'XL', stock:4},
        {id:'51347251495200',color:'Rojo',size:'2XL',stock:4},
        {id:'51347251527968',color:'Rojo',size:'3XL',stock:4},
      ]
    },
    {
      id:'10206674190624', type:'singlet', price:75000,
      handle:'costa-rica-national-team-singlet-stretchdry-max™',
      title:'COSTA RICA NATIONAL TEAM SINGLET',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPTImage16feb2026_04_56_30p.m..png?v=1771271805',
      sizes:['XS','S','M','L','XL','XXL','3XL','4XL'],
      variants:[
        {id:'51244237848864',size:'XS', stock:2},
        {id:'51244237881632',size:'S',  stock:2},
        {id:'51244237914400',size:'M',  stock:2},
        {id:'51244237947168',size:'L',  stock:2},
        {id:'51244237979936',size:'XL', stock:2},
        {id:'51244238012704',size:'XXL',stock:2},
        {id:'51244238045472',size:'3XL',stock:2},
        {id:'51244238078240',size:'4XL',stock:2},
      ]
    },
    {
      id:'10206677729568', type:'singlet', price:75000, colabLink:true,
      handle:'custom-wrestling-singlet-personalized-competition-gear-usa-worldwide-shipping',
      title:'Custom Wrestling Singlet – Personalized',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPTImage16feb2026_05_07_06p.m..png?v=1771272906',
      sizes:['XS','S','M','L','XL','XXL','3XL'],
      variants:[
        {id:'51244255281440',size:'XS', stock:2},
        {id:'51244255084832',size:'S',  stock:2},
        {id:'51244255117600',size:'M',  stock:2},
        {id:'51244255150368',size:'L',  stock:2},
        {id:'51244255183136',size:'XL', stock:2},
        {id:'51244255215904',size:'XXL',stock:2},
        {id:'51244255248672',size:'3XL',stock:2},
      ]
    },
    {
      id:'10067094929696', type:'singlet', price:65000,
      handle:'uniforme-de-boxeo-luchador®',
      title:'UNIFORME DE BOXEO – LUCHADOR®',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPTImage7oct2025_12_53_05a.m..png?v=1759812818',
      sizes:['XS','S','M','L','XL'],
      variants:[
        {id:'50769508729120',size:'XS',stock:3},
        {id:'51080362918176',size:'S', stock:3},
        {id:'51080362950944',size:'M', stock:3},
        {id:'51080362983712',size:'L', stock:4},
        {id:'51080363016480',size:'XL',stock:3},
      ]
    },
    {
      id:'10061941473568', type:'singlet', price:60000,
      handle:'wrestling-singlets-honduras',
      title:'WRESTLING SINGLETS HONDURAS 2025–2026',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPTImage29sept2025_02_16_19a.m..png?v=1759123015',
      variants:[{id:'50745970229536',size:'Única',stock:10}]
    },
    {
      id:'10062752645408', type:'singlet', price:75000,
      handle:'wrestling-singlets-turkey-2025-2026',
      title:'TURKEY WRESTLING SINGLETS UWW 2025–2026',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPTImage29sept2025_10_39_33p.m..png?v=1759200075',
      variants:[{id:'50747871330592',size:'Única',stock:3}]
    },
    // ── SHORTS ──
    {
      id:'10488232116512', type:'short', badge:'New', price:60000,
      handle:'luchador-grappling-team-short-luchador®',
      title:'SHORT TEAM LUCHADOR – LUCHADOR®',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/SHORT_LUCHADOR_TEAM_4b478ed8-12b8-4148-8230-2dc7dff93903.png?v=1788590168',
      sizes:['XS','S','M','L','XL','XXL'],
      variants:[
        {id:'52013802094880',size:'XS', stock:1},
        {id:'52013802127648',size:'S',  stock:4},
        {id:'52013802160416',size:'M',  stock:2},
        {id:'52013802193184',size:'L',  stock:5},
        {id:'52013802225952',size:'XL', stock:3},
        {id:'52013802258720',size:'XXL',stock:1},
      ]
    },
    {
      // Tarjeta unificada: Rojo y Azul son DOS productos distintos en Shopify.
      // El id es el del rojo (se usa para las reglas de conjunto y el carrito);
      // handleByColor permite consultar el stock real de cada uno por separado.
      id:'10488231854368', type:'short', badge:'New', price:60000,
      handle:'chile-short-red-luchador®',
      handleByColor:{
        'Rojo':'chile-short-red-luchador®',
        'Azul':'chile-short-blue-luchador®',
      },
      title:'SHORT CHILE – LUCHADOR®',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/SHORT_CHILE_OFICIAL_5ebecd75-788d-4161-8c39-fb2ed37b3947.png?v=1787081286',
      colors:['Rojo','Azul'],
      colorImgs:{
        'Rojo':'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/SHORT_CHILE_OFICIAL_5ebecd75-788d-4161-8c39-fb2ed37b3947.png?v=1787081286',
        'Azul':'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/SHORT_CHILE_OFICIAL_BLUE_e376c82e-8bda-4a46-a03c-f3f1477dd5d7.png?v=1787081290',
      },
      sizes:['XS','S','M','L','XL','XXL'],
      variants:[
        {id:'52013801210144',color:'Rojo',size:'XS', stock:1},
        {id:'52013801242912',color:'Rojo',size:'S',  stock:2},
        {id:'52013801275680',color:'Rojo',size:'M',  stock:3},
        {id:'52013801308448',color:'Rojo',size:'L',  stock:3},
        {id:'52013801341216',color:'Rojo',size:'XL', stock:3},
        {id:'52013801373984',color:'Rojo',size:'XXL',stock:2},
        {id:'52013801505056',color:'Azul',size:'XS', stock:1},
        {id:'52013801537824',color:'Azul',size:'S',  stock:1},
        {id:'52013801570592',color:'Azul',size:'M',  stock:3},
        {id:'52013801603360',color:'Azul',size:'L',  stock:4},
        {id:'52013801636128',color:'Azul',size:'XL', stock:3},
        {id:'52013801668896',color:'Azul',size:'XXL',stock:3},
      ]
    },
    {
      id:'10593287536928', type:'short', badge:'New', price:60000,
      handle:'short-verde-agua-luchador®',
      title:'SHORT VERDE AGUA – LUCHADOR®',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPT_Image_12_sept_2026_12_32_28_a.m..png?v=1789183963',
      sizes:['XS','S','M','L','XL','XXL'],
      variants:[
        {id:'52344410276128',size:'XS', stock:2},
        {id:'52344410308896',size:'S',  stock:2},
        {id:'52344410341664',size:'M',  stock:2},
        {id:'52344410374432',size:'L',  stock:2},
        {id:'52344410407200',size:'XL', stock:0},
        {id:'52344410439968',size:'XXL',stock:0},
      ]
    },
    {
      id:'9987649241376', type:'short', badge:'New', price:55000,
      handle:'short-luchador-pro-grappler',
      title:'Short Grappling Chile | Pro Grappler',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPT_Image_27_abr_2026_05_18_54_p.m..png?v=1777324753',
      colors:['Negro','Gris','Beige'],
      colorImgs:{
        'Negro':'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPT_Image_27_abr_2026_05_18_54_p.m..png?v=1777324753',
        'Gris' :'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPT_Image_27_abr_2026_05_10_32_p.m..png?v=1777324332',
        'Beige':'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPT_Image_27_abr_2026_05_22_59_p.m..png?v=1777324991',
      },
      sizes:['XS','S','M','L','XL','2XL','3XL'],
      variants:[
        {id:'51084509905184',color:'Negro',size:'XS', stock:0},
        {id:'51084509937952',color:'Negro',size:'S',  stock:5},
        {id:'51084509970720',color:'Negro',size:'M',  stock:5},
        {id:'51084510003488',color:'Negro',size:'L',  stock:5},
        {id:'51084510036256',color:'Negro',size:'XL', stock:5},
        {id:'51084510069024',color:'Negro',size:'2XL',stock:0},
        {id:'51084510101792',color:'Negro',size:'3XL',stock:0},
        {id:'51084509675808',color:'Gris', size:'XS', stock:0},
        {id:'51084509708576',color:'Gris', size:'S',  stock:1},
        {id:'51084509741344',color:'Gris', size:'M',  stock:0},
        {id:'51084509774112',color:'Gris', size:'L',  stock:0},
        {id:'51084509806880',color:'Gris', size:'XL', stock:2},
        {id:'51084509839648',color:'Gris', size:'2XL',stock:0},
        {id:'51084509872416',color:'Gris', size:'3XL',stock:0},
        {id:'51244345590048',color:'Beige',size:'XS', stock:0},
        {id:'51244345622816',color:'Beige',size:'S',  stock:0},
        {id:'51244345655584',color:'Beige',size:'M',  stock:0},
        {id:'51244345688352',color:'Beige',size:'L',  stock:1},
        {id:'51244345721120',color:'Beige',size:'XL', stock:3},
        {id:'51244345753888',color:'Beige',size:'2XL',stock:0},
        {id:'51244345786656',color:'Beige',size:'3XL',stock:0},
      ]
    },
    // ── ROPA ──
    {
      id:'10579816677664', type:'ropa', badge:'New', price:55000,
      handle:'leggins-pro-luchador-negro',
      title:'LEGGINS PRO LUCHADOR – NEGRO',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/LEGGINS_PRO_LUCHADOR_NEGRO.png?v=1788587355',
      sizes:['XS','S','M','L','XL','XXL'],
      variants:[
        {id:'52306357616928',size:'XS', stock:3},
        {id:'52306357649696',size:'S',  stock:3},
        {id:'52306357682464',size:'M',  stock:3},
        {id:'52306357715232',size:'L',  stock:3},
        {id:'52306357748000',size:'XL', stock:3},
        {id:'52306357780768',size:'XXL',stock:1},
      ]
    },
    {
      id:'10579816775968', type:'ropa', badge:'New', price:55000,
      handle:'leggins-pro-luchador-turquesa',
      title:'LEGGINS PRO LUCHADOR – TURQUESA',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/leggins_pro_luchador_turquesa.png?v=1788589750',
      sizes:['XS','S','M','L','XL','XXL'],
      variants:[
        {id:'52306358108448',size:'XS', stock:3},
        {id:'52306358141216',size:'S',  stock:3},
        {id:'52306358173984',size:'M',  stock:3},
        {id:'52306358206752',size:'L',  stock:3},
        {id:'52306358239520',size:'XL', stock:3},
        {id:'52306358272288',size:'XXL',stock:1},
      ]
    },
    {
      id:'9987587670304', type:'ropa', price:49990,
      handle:'poleron-luchador',
      title:'POLERON WRESTLING ART – RUDEBOYS X LUCHADOR®',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPTImage29jun2025_10_53_48p.m..png?v=1751254405',
      sizes:['XS','S','M','L','XL','2XL'],
      variants:[
        {id:'51443595018528',size:'XS', stock:0},
        {id:'51443595051296',size:'S',  stock:1},
        {id:'51443595084064',size:'M',  stock:2},
        {id:'51443595116832',size:'L',  stock:1},
        {id:'51443595149600',size:'XL', stock:3},
        {id:'51443595182368',size:'2XL',stock:2},
      ]
    },
    {
      id:'10279670186272', type:'ropa', price:49990,
      handle:'poleron-luchador-rudeboys-x-luchador®',
      title:'POLERON LUCHADOR AZUL – RUDEBOYS X LUCHADOR®',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPT_Image_13_abr_2026_12_55_01_a.m..png?v=1776056113',
      sizes:['XS','S','M','L','XL','2XL'],
      variants:[
        {id:'51477856387360',size:'XS', stock:0},
        {id:'51477856420128',size:'S',  stock:2},
        {id:'51477856452896',size:'M',  stock:2},
        {id:'51477856485664',size:'L',  stock:1},
        {id:'51477856518432',size:'XL', stock:0},
        {id:'51477856551200',size:'2XL',stock:0},
      ]
    },
    {
      id:'10268364898592', type:'ropa', price:28000,
      handle:'premium-tee-luchador-x-rudeboys',
      title:'PREMIUM TEE – LUCHADOR x RUDEBOYS',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPTImage7abr2026_11_09_22a.m..png?v=1775574574',
      sizes:['XS','S','M','L','XL','2XL'],
      variants:[
        {id:'51447145234720',size:'XS', stock:0},
        {id:'51447145267488',size:'S',  stock:6},
        {id:'51447145300256',size:'M',  stock:0},
        {id:'51447145333024',size:'L',  stock:0},
        {id:'51447145365792',size:'XL', stock:2},
        {id:'51447145398560',size:'2XL',stock:0},
      ]
    },
    {
      id:'10249105244448', type:'ropa', price:43990,
      handle:'luchador-mesh-jersey-black',
      title:'LUCHADOR MESH JERSEY – BLACK',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/0F0C0A18-B7B4-4FE2-A93F-226CB0C9C4C4.png?v=1775025742',
      sizes:['XS','S','M','L','XL','2XL'],
      variants:[
        {id:'51488456474912',size:'XS', stock:0},
        {id:'51488456507680',size:'S',  stock:2},
        {id:'51488456540448',size:'M',  stock:5},
        {id:'51488456442144',size:'L',  stock:7},
        {id:'51488456573216',size:'XL', stock:1},
        {id:'51488456605984',size:'2XL',stock:0},
      ]
    },
    // ── ACCESORIOS ──
    {
      id:'10207527797024', type:'accesorios', price:24990,
      handle:'morral-luchador®-performance-45-x-40-cm',
      title:'MORRAL LUCHADOR® PERFORMANCE',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/WhatsAppImage2026-02-12at12.14.03.jpg?v=1771351502',
      colors:['Negro','Geométrico'],
      colorImgs:{
        'Negro'     :'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/WhatsAppImage2026-02-12at12.14.03.jpg?v=1771351502',
        'Geométrico':'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/WhatsAppImage2026-02-12at12.13.57.jpg?v=1771351502',
      },
      variants:[
        {id:'51246655635744',color:'Negro',     size:'Negro',      stock:10},
        {id:'51246655668512',color:'Geométrico',size:'Geométrico', stock:10},
      ]
    },
    {
      id:'10287351398688', type:'accesorios', price:5500,
      handle:'lanyard-premium-luchador®',
      title:'LANYARD PREMIUM LUCHADOR®',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/ChatGPTImage24abr2026_11_52_55p.m..png?v=1777089189',
      variants:[{id:'51515170357536',size:'Única',stock:89}]
    },
    {
      id:'10533512249632', type:'accesorios', price:75000,
      handle:'mochila-oficial-chile-wrestling',
      title:'Mochila Oficial Chile Wrestling',
      img:'https://cdn.shopify.com/s/files/1/0955/0734/9792/files/MOCHILA_CHILE_WRESTLING_b95ce05d-4109-441f-92d3-206bb5a8c7eb.png?v=1786030397',
      variants:[{id:'52156749414688',size:'Única',stock:35}]
    },
  ],

  // ═══════════════════════════════════════════════════
  // REGLA DE CONJUNTOS — rashguard <-> short
  // sameColor:true hace que el par herede el color elegido (Chile rojo con
  // rojo, azul con azul). El id 10488231985440 sigue mapeado porque el short
  // azul llega al carrito como producto propio, aunque en la web sea una sola
  // tarjeta.
  // ═══════════════════════════════════════════════════
  conjuntos:{
    '10488232116512':{ id:'10331672510752' },
    '10331672510752':{ id:'10488232116512' },
    '10488231854368':{ id:'10233733710112', sameColor:true },
    '10488231985440':{ id:'10233733710112', color:'Azul' },
    '10233733710112':{ id:'10488231854368', sameColor:true },
  },
  getConjunto(p, color){
    if(!p) return null;
    const rule = this.conjuntos[p.id];
    if(!rule) return null;
    let partnerId = rule.id, partnerColor = rule.color || null;
    if(rule.sameColor) partnerColor = color || null;
    if(rule.byColor){
      const key = (color && rule.byColor[color]) ? color : Object.keys(rule.byColor)[0];
      partnerId = rule.byColor[key];
      partnerColor = null;
    }
    if(!partnerId) return null;
    const partner = this.products.find(x=>x.id===partnerId);
    if(!partner) return null;
    if(partnerColor && partner.colors && partner.colors.indexOf(partnerColor)===-1) partnerColor = null;
    return { partner, partnerColor };
  },
  conjuntoImg(p, color){
    return (color && p.colorImgs && p.colorImgs[color]) ? p.colorImgs[color] : p.img;
  },
  openConjunto(id, color){
    this.openModal(id);
    if(color) this.selectColor(color);
    const box = document.querySelector('#luch-modal-overlay .luch-modal');
    if(box) box.scrollTop = 0;
  },
  renderConjuntoBlock(p){
    const cj = this.getConjunto(p, this.selectedColor);
    if(!cj) return '';
    const img = this.conjuntoImg(cj.partner, cj.partnerColor);
    const arg = cj.partnerColor ? `'${cj.partner.id}','${cj.partnerColor}'` : `'${cj.partner.id}'`;
    return `<div id="luch-conjunto" style="margin-top:1.4rem;border-top:1px solid #e6e6e6;padding-top:1.1rem">
      <p style="font-size:0.6rem;font-weight:800;letter-spacing:0.14em;text-transform:uppercase;color:#9a9a9a;margin:0 0 0.7rem">Completa el conjunto</p>
      <div style="display:flex;align-items:center;gap:0.85rem;background:#f7f7f7;padding:0.7rem;cursor:pointer" onclick="LUCH.openConjunto(${arg})">
        <img src="${img}" alt="${cj.partner.title}" style="width:62px;height:62px;object-fit:cover;flex-shrink:0;background:#fff">
        <div style="flex:1;min-width:0">
          <p style="font-size:0.58rem;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;color:#9a9a9a;margin:0 0 0.15rem">${this.getTypeLabel(cj.partner.type)}</p>
          <p style="font-size:0.78rem;font-weight:800;margin:0;line-height:1.25;color:#0a0a0a">${cj.partner.title}</p>
          <p style="font-size:0.75rem;font-weight:700;margin:0.2rem 0 0;color:#0a0a0a">${this.fmtPrice(cj.partner.price)}</p>
        </div>
        <span style="font-size:0.62rem;font-weight:800;letter-spacing:0.08em;text-transform:uppercase;background:#0a0a0a;color:#fff;padding:0.5rem 0.7rem;white-space:nowrap">Ver &rarr;</span>
      </div>
    </div>`;
  },
  conjuntoSuggestions(cart){
    const inCart = new Set((cart.items||[]).map(i=>String(i.product_id)));
    const seen = new Set();
    const out = [];
    (cart.items||[]).forEach(item=>{
      const rule = this.conjuntos[String(item.product_id)];
      if(!rule) return;
      let partnerId = rule.id, partnerColor = rule.color || null;
      const vt = String(item.variant_title||'').toLowerCase();
      if(rule.sameColor){
        const partnerPeek = this.products.find(x=>x.id===partnerId);
        const cs = (partnerPeek && partnerPeek.colors) || [];
        partnerColor = cs.find(c=>vt.indexOf(c.toLowerCase())!==-1) || null;
      }
      if(rule.byColor){
        const key = Object.keys(rule.byColor).find(c=>vt.indexOf(c.toLowerCase())!==-1);
        partnerId = rule.byColor[key || Object.keys(rule.byColor)[0]];
        partnerColor = null;
      }
      if(!partnerId || inCart.has(partnerId) || seen.has(partnerId)) return;
      const p = this.products.find(x=>x.id===partnerId);
      if(!p) return;
      seen.add(partnerId);
      out.push({ p, color: partnerColor });
    });
    return out;
  },
  renderConjuntoDrawer(cart){
    const sugg = this.conjuntoSuggestions(cart);
    if(!sugg.length) return '';
    return `<div style="margin-top:1.1rem;border-top:1px solid #e6e6e6;padding-top:1rem">
      <p style="font-size:0.6rem;font-weight:800;letter-spacing:0.14em;text-transform:uppercase;color:#9a9a9a;margin:0 0 0.7rem">Completa tu conjunto</p>
      ${sugg.map(s=>{
        const img = this.conjuntoImg(s.p, s.color);
        const arg = s.color ? `'${s.p.id}','${s.color}'` : `'${s.p.id}'`;
        return `<div style="display:flex;align-items:center;gap:0.8rem;background:#f7f7f7;padding:0.65rem;margin-bottom:0.5rem;cursor:pointer" onclick="LUCH.closeCartDrawer();LUCH.openConjunto(${arg})">
          <img src="${img}" alt="${s.p.title}" style="width:54px;height:54px;object-fit:cover;background:#fff;flex-shrink:0">
          <div style="flex:1;min-width:0">
            <p style="font-size:0.58rem;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;color:#9a9a9a;margin:0 0 0.15rem">${this.getTypeLabel(s.p.type)}</p>
            <p style="font-size:0.72rem;font-weight:800;margin:0;line-height:1.25;color:#0a0a0a">${s.p.title}</p>
            <p style="font-size:0.72rem;font-weight:700;margin:0.15rem 0 0;color:#0a0a0a">${this.fmtPrice(s.p.price)}</p>
          </div>
          <span style="font-size:0.6rem;font-weight:800;letter-spacing:0.08em;text-transform:uppercase;background:#0a0a0a;color:#fff;padding:0.45rem 0.65rem;white-space:nowrap">Ver &rarr;</span>
        </div>`;
      }).join('')}
    </div>`;
  },

  fmtPrice(n){ return '$'+Math.round(n).toLocaleString('es-CL'); },
  getTypeLabel(t){ return {rashguard:'Rashguard',singlet:'Singlet / Malla',short:'Short',ropa:'Ropa',accesorios:'Accesorio',conjunto:'Conjunto',evento:'Evento'}[t]||t; },
  swatchColors:{Rojo:'#c0392b',Azul:'#1a3a8f',Negro:'#111',Gris:'#a5a5a5',Blanco:'#ecf0f1',Beige:'#c3a882','Verde Agua':'#a8d5c8',Geométrico:'#555',Única:'#888'},

  renderCard(p){
    const hasColors = p.colorImgs && p.colors && p.colors.length > 1;
    const colorDots = hasColors ? `
      <div class="luch-card-colors" onclick="event.stopPropagation()">
        ${p.colors.map((c,i)=>{
          const sw=this.swatchColors[c]||'#888';
          const border=c==='Blanco'?'border:1.5px solid #ccc;':'';
          return `<button class="luch-card-dot${i===0?' active':''}" style="background:${sw};${border}"
            onclick="LUCH.cycleCardColor('${p.id}','${c}',this)" title="${c}"></button>`;
        }).join('')}
      </div>` : '';
    const arrows = hasColors ? `
      <button class="luch-card-arrow left" onclick="event.stopPropagation();LUCH.cycleCard('${p.id}',-1)">&#8249;</button>
      <button class="luch-card-arrow right" onclick="event.stopPropagation();LUCH.cycleCard('${p.id}',1)">&#8250;</button>` : '';
    const badge = p.badge ? `<span class="luch-card-badge">${p.badge}</span>` : '';
    const colorCount = hasColors ? `<span style="font-size:0.6rem;font-weight:700;letter-spacing:0.08em;color:#9a9a9a;text-transform:uppercase">${p.colors.length} colores</span>` : '';
    return `<div class="luch-card" onclick="LUCH.openModal('${p.id}')" id="card-${p.id}">
      <div class="luch-card-img">
        <img src="${p.img}" alt="${p.title}" loading="lazy" id="card-img-${p.id}">
        ${arrows}
        <div class="luch-card-overlay">
          <button class="luch-card-overlay-btn" onclick="event.stopPropagation();LUCH.openModal('${p.id}')">Ver Producto</button>
        </div>
      </div>
      ${badge}
      <div class="luch-card-info">
        <p class="luch-card-type">${this.getTypeLabel(p.type)}</p>
        <p class="luch-card-name">${p.title}</p>
        <div class="luch-card-bottom">
          <p class="luch-card-price">${this.fmtPrice(p.price)}</p>
          ${colorCount}
        </div>
        ${colorDots}
      </div>
    </div>`;
  },

  cardColorIndex:{},
  cycleCard(id,dir){
    const p=this.products.find(x=>x.id===id);
    if(!p||!p.colors) return;
    const cur=this.cardColorIndex[id]||0;
    const next=(cur+dir+p.colors.length)%p.colors.length;
    this.cardColorIndex[id]=next;
    const img=document.getElementById('card-img-'+id);
    if(img&&p.colorImgs[p.colors[next]]) img.src=p.colorImgs[p.colors[next]];
    document.getElementById('card-'+id)?.querySelectorAll('.luch-card-dot').forEach((d,i)=>d.classList.toggle('active',i===next));
  },
  cycleCardColor(id,color,btn){
    const p=this.products.find(x=>x.id===id);
    if(!p||!p.colors) return;
    const idx=p.colors.indexOf(color);
    if(idx===-1) return;
    this.cardColorIndex[id]=idx;
    const img=document.getElementById('card-img-'+id);
    if(img&&p.colorImgs[color]) img.src=p.colorImgs[color];
    document.getElementById('card-'+id)?.querySelectorAll('.luch-card-dot').forEach((d,i)=>d.classList.toggle('active',i===idx));
  },

  init(){
    ['luch-home-grid','luch-store-grid'].forEach(gid=>{
      const g=document.getElementById(gid);
      if(g) g.innerHTML=this.products.map(p=>this.renderCard(p)).join('');
    });
    const cnt=document.getElementById('luch-count');
    if(cnt) cnt.textContent=this.products.length+' productos';
    this.startSlider();
    this.calcTotal();
    this.checkPage();
    this.syncCartCount();
    this.initHistory();
  },

  showPage(page){
    document.querySelectorAll('.luch-page').forEach(p=>p.classList.remove('active'));
    const el=document.getElementById('luch-page-'+page);
    if(el){el.classList.add('active');}else{document.getElementById('luch-page-home')?.classList.add('active');page='home';}
    document.querySelectorAll('.luch-nav-links a').forEach(a=>a.classList.toggle('active',a.dataset.page===page));
    document.getElementById('luch-modal-overlay')?.classList.remove('open');
    document.getElementById('luch-cart-drawer')?.classList.remove('open');
    document.body.style.overflow='';
    window.scrollTo({top:0,behavior:'smooth'});
    try{history.pushState({page},'',page==='home'?'/':'/?page='+page);}catch(e){}
  },
  checkPage(){
    const path0 = window.location.pathname;
    if(path0.startsWith('/products/')){ return; }
    const params = new URLSearchParams(window.location.search);
    const pageParam = params.get('page');
    if(pageParam){ this.showPage(pageParam); return; }
    const path = window.location.pathname;
    if(path.includes('colaboraciones')) this.showPage('colaboraciones');
    else if(path.includes('terminos'))  this.showPage('terminos');
    else if(path.includes('proyectos')) this.showPage('proyectos');
    else if(path.includes('solidario')) this.showPage('solidario');
    else if(path.includes('tienda'))    this.showPage('tienda');
    else this.showPage('home');
  },
  initHistory(){
    window.addEventListener('popstate',e=>{
      let page = e.state?.page;
      if(!page){ const params = new URLSearchParams(window.location.search); page = params.get('page') || 'home'; }
      document.querySelectorAll('.luch-page').forEach(p=>p.classList.remove('active'));
      const el = document.getElementById('luch-page-'+page);
      if(el){ el.classList.add('active'); } else { document.getElementById('luch-page-home')?.classList.add('active'); page='home'; }
      document.querySelectorAll('.luch-nav-links a').forEach(a=>a.classList.toggle('active',a.dataset.page===page));
      document.body.style.overflow='';
      window.scrollTo({top:0});
    });
  },
  filterProducts(cat,btn){
    document.querySelectorAll('.luch-filter').forEach(b=>b.classList.remove('active'));
    btn.classList.add('active');
    const grid=document.getElementById('luch-store-grid');
    const filtered=cat==='all'?this.products:this.products.filter(p=>p.type===cat);
    if(grid) grid.innerHTML=filtered.map(p=>this.renderCard(p)).join('');
  },
  toggleMobile(){
    const m=document.getElementById('luch-mobile-menu');
    if(m) m.style.display=m.style.display==='block'?'none':'block';
  },

  async addToShopifyCart(variantId,quantity){
    try{
      const res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:String(variantId),quantity}]})});
      const data=await res.json();
      if(!res.ok) throw new Error(data.description||'No hay stock disponible');
      await this.syncCartCount();
      return true;
    }catch(err){this.showToast(err.message);return false;}
  },
  async syncCartCount(){
    try{
      const d=await(await fetch('/cart.js')).json();
      const count=d.item_count||0;
      const badge=document.getElementById('luch-cart-count');
      if(badge){badge.textContent=count;badge.style.display=count>0?'flex':'none';}
    }catch(e){}
  },

  currentProduct:null, selectedVariantId:null, selectedColor:null, selectedSize:null,

  // Un producto puede mapear a más de un handle de Shopify (tarjeta unificada).
  handleFor(p, color){
    if(p.handleByColor){
      const c = color || this.selectedColor || (p.colors && p.colors[0]);
      return p.handleByColor[c] || p.handle;
    }
    return p.handle;
  },
  handlesOf(p){
    if(p.handleByColor) return Object.keys(p.handleByColor).map(k=>p.handleByColor[k]);
    return p.handle ? [p.handle] : [];
  },

  _liveStock:{}, _liveStockPromise:{},
  async fetchLiveStock(handle){
    if(!handle) return null;
    if(this._liveStock[handle]) return this._liveStock[handle];
    if(this._liveStockPromise[handle]) return this._liveStockPromise[handle];
    const p = (async()=>{
      try{
        const res = await fetch('/products/'+handle+'.js');
        if(!res.ok) return null;
        const data = await res.json();
        const map = {};
        (data.variants||[]).forEach(v=>{ map[String(v.id)] = !!v.available; });
        this._liveStock[handle] = map;
        return map;
      }catch(e){ return null; }
    })();
    this._liveStockPromise[handle] = p;
    return p;
  },
  isVariantAvailable(p, v){
    if(!v) return false;
    const live = this._liveStock[this.handleFor(p, v.color)];
    if(live && Object.prototype.hasOwnProperty.call(live, String(v.id))) return live[String(v.id)];
    return v.stock>0;
  },

  openModal(id){
    const p=this.products.find(x=>x.id===id);
    if(!p) return;
    this.currentProduct=p;
    this.selectedColor=p.colors?.length ? p.colors[0] : null;
    this.selectedSize=null;
    this.selectedVariantId=null;
    if(p.variants.length===1){
      this.selectedVariantId=p.variants[0].id;
      this.selectedSize=p.variants[0].size;
    }
    if(p.colors?.length && !p.sizes){
      const def=p.variants.find(v=>v.color===this.selectedColor);
      if(def){this.selectedVariantId=def.id;this.selectedSize=def.color;}
    }
    this.renderModal(p);
    const hs=this.handlesOf(p);
    if(hs.length){
      Promise.all(hs.map(h=>this.fetchLiveStock(h))).then(()=>{ if(this.currentProduct===p) this.renderModal(p); });
    }
    document.getElementById('luch-modal-overlay').classList.add('open');
    document.body.style.overflow='hidden';
  },

  renderModal(p){
    document.getElementById('luch-modal-title').textContent=p.title;
    const imgEl=document.getElementById('luch-modal-img');
    imgEl.src=(this.selectedColor && p.colorImgs?.[this.selectedColor]) ? p.colorImgs[this.selectedColor] : p.img;
    imgEl.alt=p.title;
    document.getElementById('luch-modal-price').textContent=this.fmtPrice(p.price);
    document.getElementById('luch-modal-desc').textContent=p.desc||'';

    document.getElementById('luch-modal-plink')?.remove();
    const ph=this.handleFor(p, this.selectedColor);
    if(ph){
      const lk=document.createElement('a');
      lk.id='luch-modal-plink'; lk.href='/products/'+ph;
      lk.className='luch-modal-product-link';
      lk.innerHTML=`<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>Ver página completa del producto`;
      document.getElementById('luch-modal-price').before(lk);
    }

    const vg=document.getElementById('luch-variant-grid');
    let html='';

    if(p.colors?.length > 1){
      html+=`<div class="luch-variant-block">
        <p class="luch-modal-label">Color</p>
        <div class="luch-color-row">`;
      p.colors.forEach(c=>{
        const active=c===this.selectedColor?' active':'';
        const bg=this.swatchColors[c]||'#888';
        html+=`<button class="luch-color-btn${active}" onclick="LUCH.selectColor('${c}')" title="${c}">
          <span class="luch-color-swatch" style="background:${bg};border:2px solid ${c==='Blanco'?'#ccc':'transparent'}"></span>
          <span>${c}</span></button>`;
      });
      html+=`</div></div>`;
    }

    const sizes=p.sizes;
    if(sizes?.length > 1){
      html+=`<div class="luch-variant-block" style="margin-top:1.1rem">
        <p class="luch-modal-label">Talla</p>
        <div class="luch-size-row">`;
      sizes.forEach(sz=>{
        const v=p.variants.find(x=> this.selectedColor ? (x.color===this.selectedColor && x.size===sz) : x.size===sz);
        const inStock=this.isVariantAvailable(p, v);
        const sel=sz===this.selectedSize?' active':'';
        const oos=!inStock?' oos':'';
        html+=`<button class="luch-size-btn${sel}${oos}" ${!inStock?'disabled':''} onclick="LUCH.selectSize('${sz}','${v?.id||''}')">${sz}</button>`;
      });
      html+=`</div></div>`;
    }

    html+=this.renderConjuntoBlock(p);

    vg.innerHTML=html;

    document.getElementById('luch-modal-colab-link')?.remove();
    if(p.colabLink){
      const lk=document.createElement('p');
      lk.id='luch-modal-colab-link';
      lk.style.cssText='font-size:0.78rem;color:#5a5a5a;margin:0.75rem 0 1rem';
      lk.innerHTML=`🤝 <a href="#" onclick="LUCH.closeModal();LUCH.showPage('colaboraciones');return false;" style="color:#0a0a0a;font-weight:700;text-decoration:underline">Cotizar pedido mayorista →</a>`;
      vg.before(lk);
    }

    const addBtn=document.querySelector('.luch-add-btn');
    if(addBtn){
      const canAdd=!!this.selectedVariantId;
      addBtn.disabled=!canAdd;
      addBtn.style.opacity=canAdd?'1':'0.5';
      addBtn.textContent=canAdd?'Agregar al carrito':'Selecciona una talla';
    }
  },

  selectColor(color){
    this.selectedColor=color;
    const p=this.currentProduct;
    if(p && !p.sizes){
      const v=p.variants.find(x=>x.color===color);
      if(v){this.selectedVariantId=v.id;this.selectedSize=v.color;}
    } else {
      this.selectedSize=null;
      this.selectedVariantId=null;
    }
    this.renderModal(p);
  },
  selectSize(sz,vid){
    this.selectedSize=sz;
    this.selectedVariantId=vid;
    this.renderModal(this.currentProduct);
  },
  closeModal(e){
    if(!e||e.target===document.getElementById('luch-modal-overlay')){
      document.getElementById('luch-modal-overlay').classList.remove('open');
      document.body.style.overflow='';
    }
  },
  async addToCart(){
    if(!this.currentProduct||!this.selectedVariantId){this.showToast('Selecciona una opción');return;}
    const btn=document.querySelector('.luch-add-btn');
    if(btn){btn.disabled=true;btn.textContent='Agregando...';}
    const ok=await this.addToShopifyCart(this.selectedVariantId,1);
    if(btn){btn.disabled=false;btn.textContent='Agregar al carrito';}
    if(ok){this.closeModal();this.openCartDrawer();}
  },
  showToast(msg){
    const t=document.getElementById('luch-toast');
    if(!t) return;
    t.textContent=msg;t.classList.add('show');
    setTimeout(()=>t.classList.remove('show'),3500);
  },

  currentSlide:0,totalSlides:3,autoplayTimer:null,
  updateSlider(){
    document.getElementById('luch-slides-track')?.style.setProperty('transform',`translateX(-${this.currentSlide*100}%)`);
    document.querySelectorAll('.luch-dot').forEach((d,i)=>d.classList.toggle('active',i===this.currentSlide));
    this.syncSliderHeight();
  },
  syncSliderHeight(){
    const slider=document.querySelector('.luch-slider');if(!slider)return;
    const img=slider.querySelectorAll('.luch-slide-img')[this.currentSlide];if(!img)return;
    const set=()=>{if(img.naturalWidth>0){const h=Math.round(slider.offsetWidth*img.naturalHeight/img.naturalWidth);if(h>0)slider.style.height=h+'px';}};
    img.complete&&img.naturalWidth?set():img.addEventListener('load',set,{once:true});
  },
  moveSlide(dir){this.currentSlide=(this.currentSlide+dir+this.totalSlides)%this.totalSlides;this.updateSlider();this.resetAutoplay();},
  goSlide(i){this.currentSlide=i;this.updateSlider();this.resetAutoplay();},
  startSlider(){
    this.autoplayTimer=setInterval(()=>this.moveSlide(1),5500);
    window.addEventListener('load',()=>this.syncSliderHeight());
    window.addEventListener('resize',()=>this.syncSliderHeight());
  },
  resetAutoplay(){clearInterval(this.autoplayTimer);this.startSlider();},

  colabPrices:{rg:38500,sh:38500,ml:55000},
  colabMins:  {rg:10,   sh:10,   ml:13  },
  colabVariants:{
    rg:'51819845976352',
    sh:'51819847319840',
    ml:'51819848171808',
  },
  changeQty(key,delta){
    const input=document.getElementById('luch-'+key+'-qty');if(!input)return;
    let v=parseInt(input.value)||0;
    const min=this.colabMins[key];
    if(delta>0){v=v===0?min:Math.min(v+1,500);}else{v=v<=min?0:v-1;}
    input.value=v;this.calcTotal();
  },
  calcTotal(){
    const g=id=>parseInt((document.getElementById(id)||{}).value)||0;
    const rg=g('luch-rg-qty'),sh=g('luch-sh-qty'),ml=g('luch-ml-qty');
    const set=(id,v)=>{const el=document.getElementById(id);if(el)el.textContent=v;};
    set('luch-rg-sub',this.fmtPrice(rg*this.colabPrices.rg));
    set('luch-sh-sub',this.fmtPrice(sh*this.colabPrices.sh));
    set('luch-ml-sub',this.fmtPrice(ml*this.colabPrices.ml));
    const totalUnits = rg + sh + ml;
    const shipping = totalUnits > 0 ? Math.max(totalUnits * 1500, 19500) : 0;
    const subtotal = rg*this.colabPrices.rg + sh*this.colabPrices.sh + ml*this.colabPrices.ml;
    const grandTotal = subtotal + shipping;
    set('luch-grand-total', this.fmtPrice(grandTotal));
    set('luch-shipping-amt', totalUnits > 0 ? this.fmtPrice(shipping) : '—');
    set('luch-subtotal-amt', this.fmtPrice(subtotal));
    const warns=[];
    if(rg>0&&rg<this.colabMins.rg)warns.push(`Rashguard mín. ${this.colabMins.rg} uds`);
    if(sh>0&&sh<this.colabMins.sh)warns.push(`Shorts mín. ${this.colabMins.sh} uds`);
    if(ml>0&&ml<this.colabMins.ml)warns.push(`Mallas mín. ${this.colabMins.ml} uds`);
    const warn=document.getElementById('luch-min-warning'),msg=document.getElementById('luch-min-msg'),cbtn=document.getElementById('luch-checkout-btn');
    if(warn&&msg){
      if(warns.length){msg.textContent='⚠️ '+warns.join(' · ');warn.style.display='block';if(cbtn){cbtn.disabled=true;cbtn.style.opacity='0.5';}}
      else{warn.style.display='none';if(cbtn){cbtn.disabled=false;cbtn.style.opacity='1';}}
    }
  },
  colabEnvioVariantId: '51820028264736',

  async goCheckout(){
    const g=id=>parseInt((document.getElementById(id)||{}).value)||0;
    const rg=g('luch-rg-qty'),sh=g('luch-sh-qty'),ml=g('luch-ml-qty');
    if(!rg&&!sh&&!ml){this.showToast('Agrega al menos un producto.');return;}
    const btn=document.getElementById('luch-checkout-btn');
    if(btn){btn.disabled=true;btn.textContent='Procesando...';}
    const totalUnits = rg+sh+ml;
    const shipping = Math.max(totalUnits*1500, 19500);
    const items=[];
    if(rg) items.push({id:this.colabVariants.rg, quantity:rg});
    if(sh) items.push({id:this.colabVariants.sh, quantity:sh});
    if(ml) items.push({id:this.colabVariants.ml, quantity:ml});
    items.push({id: this.colabEnvioVariantId, quantity: shipping, properties: {'_envio_colaboracion': 'true', 'Unidades': String(totalUnits)}});
    try{
      await fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}});
      const res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      if(!res.ok){const d=await res.json();throw new Error(d.description||'Error');}
      await this.syncCartCount();
      window.location.href='/checkout?discount=&note=colaboracion';
    }catch(err){
      if(btn){btn.disabled=false;btn.textContent='🛒 Agregar al Carrito e Ir a Pagar →';}
      this.showToast('Error: '+err.message);
    }
  },

  openCartDrawer(){
    const d=document.getElementById('luch-cart-drawer');
    if(d){this.refreshCartDrawer();d.classList.add('open');document.body.style.overflow='hidden';}
  },
  closeCartDrawer(){
    const d=document.getElementById('luch-cart-drawer');
    if(d){d.classList.remove('open');document.body.style.overflow='';}
  },
  colabProductIds: {
    10382088339744: 10,
    10382089453856: 10,
    10382090109216: 13,
  },
  colabEnvioProductId: 10382171275552,

  async refreshCartDrawer(){
    try{
      const cart=await(await fetch('/cart.js')).json();
      const body=document.getElementById('luch-drawer-items');
      const empty=document.getElementById('luch-drawer-empty');
      const footer=document.getElementById('luch-drawer-footer');
      const total=document.getElementById('luch-drawer-total');
      if(!body)return;
      if(cart.item_count===0){
        body.innerHTML='';
        if(empty)empty.style.display='block';
        if(footer)footer.style.display='none';
      }else{
        if(empty)empty.style.display='none';
        if(footer)footer.style.display='block';
        body.innerHTML=cart.items.map(item=>{
          if(item.product_id===this.colabEnvioProductId){
            return `<div class="luch-drawer-item" style="background:#f8f8f8;border-left:3px solid #0a0a0a">
                <div style="width:72px;height:72px;background:#0a0a0a;display:flex;align-items:center;justify-content:center;flex-shrink:0">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.8"><rect x="1" y="3" width="15" height="13"/><path d="M16 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
                </div>
                <div class="luch-drawer-info">
                  <p class="luch-drawer-name" style="font-weight:800">Envío Colaboración</p>
                  <p class="luch-drawer-variant" style="color:#5a5a5a">$1.500 × ${item.properties?.Unidades||'?'} unidades</p>
                </div>
                <p class="luch-drawer-price">$${Math.round(item.quantity).toLocaleString('es-CL')}</p>
              </div>`;
          }
          const minQty = this.colabProductIds[item.product_id];
          if(minQty){
            const canDecrease = item.quantity > minQty;
            return `<div class="luch-drawer-item">
                <img src="${item.image}" alt="${item.product_title}" class="luch-drawer-img">
                <div class="luch-drawer-info">
                  <p class="luch-drawer-name">${item.product_title}</p>
                  <p class="luch-drawer-variant">${item.variant_title&&item.variant_title!=='Default Title'?item.variant_title:''}</p>
                  <p class="luch-drawer-variant" style="color:#e74c3c;font-size:0.65rem">Mínimo ${minQty} uds</p>
                  <div class="luch-drawer-qty-row">
                    <button onclick="LUCH.drawerColabQty('${item.key}',${item.quantity-1},${minQty})" class="luch-drawer-qty-btn" ${!canDecrease?'disabled style="opacity:0.3;cursor:not-allowed"':''}>−</button>
                    <span class="luch-drawer-qty-num">${item.quantity}</span>
                    <button onclick="LUCH.drawerColabQty('${item.key}',${item.quantity+1},${minQty})" class="luch-drawer-qty-btn">+</button>
                    <button onclick="LUCH.drawerColabQty('${item.key}',0,0)" class="luch-drawer-remove">Eliminar</button>
                  </div>
                </div>
                <p class="luch-drawer-price">$${Math.round(item.final_line_price/100).toLocaleString('es-CL')}</p>
              </div>`;
          }
          return `<div class="luch-drawer-item">
              <img src="${item.image}" alt="${item.product_title}" class="luch-drawer-img">
              <div class="luch-drawer-info">
                <p class="luch-drawer-name">${item.product_title}</p>
                <p class="luch-drawer-variant">${item.variant_title&&item.variant_title!=='Default Title'?item.variant_title:''}</p>
                <div class="luch-drawer-qty-row">
                  <button onclick="LUCH.drawerChangeQty('${item.key}',${item.quantity-1})" class="luch-drawer-qty-btn">−</button>
                  <span class="luch-drawer-qty-num">${item.quantity}</span>
                  <button onclick="LUCH.drawerChangeQty('${item.key}',${item.quantity+1})" class="luch-drawer-qty-btn">+</button>
                  <button onclick="LUCH.drawerChangeQty('${item.key}',0)" class="luch-drawer-remove">Eliminar</button>
                </div>
              </div>
              <p class="luch-drawer-price">$${Math.round(item.final_line_price/100).toLocaleString('es-CL')}</p>
            </div>`;
        }).join('') + this.renderConjuntoDrawer(cart);
        if(total)total.textContent='$'+Math.round(cart.total_price/100).toLocaleString('es-CL');
      }
      const badge=document.getElementById('luch-cart-count');
      if(badge){badge.textContent=cart.item_count;badge.style.display=cart.item_count>0?'flex':'none';}
    }catch(e){console.error(e);}
  },

  async drawerColabQty(key, qty, minQty){
    if(qty !== 0 && qty < minQty) return;
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    const item = cart.items.find(i=>i.key===key);
    if(!item) return;
    const delta = qty - item.quantity;
    const colabItems = cart.items.filter(i=>this.colabProductIds[i.product_id]);
    const currentColabTotal = colabItems.reduce((s,i)=>s+i.quantity, 0);
    const newColabTotal = qty === 0 ? currentColabTotal - item.quantity : currentColabTotal + delta;
    await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})});
    if(newColabTotal > 0){
      const envioItem = cart.items.find(i=>i.product_id===this.colabEnvioProductId);
      const newEnvio = Math.max(newColabTotal * 1500, 19500);
      if(envioItem){ await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:envioItem.key, quantity:newEnvio})}); }
    } else {
      const envioItem = cart.items.find(i=>i.product_id===this.colabEnvioProductId);
      if(envioItem){ await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:envioItem.key, quantity:0})}); }
    }
    this.refreshCartDrawer();
    this.syncCartCount();
  },
  async drawerChangeQty(key,qty){
    await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})});
    this.refreshCartDrawer();this.syncCartCount();
  },
  submitQuote(e){e.preventDefault();this.showToast('¡Cotización enviada!');e.target.reset();this.calcTotal();}
};

document.addEventListener('DOMContentLoaded',()=>LUCH.init());
